<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-25 14:02:28
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2022-10-25 17:54:46
 * @Description: 描述
 -->

<template>
    <div>
        <template v-if="layout === 'table'">
            <template v-if="!disabled || !tableScroll">
                <a-table
                    :scroll="{ x: totalWidth, y: 424 }"
                    size="small"
                    :dataSource="dataSource"
                    :pagination="false"
                    :rowSelection="rowSelection"
                    :columns="tableColumns"
                    @change="handlePageChange"
                >
                    <!-- 标题列 -->
                    <template
                        v-for="(field, key) in visibleFieldColumn"
                        :slot="field.slots.title"
                    >
                        <div :key="key" v-html="renderTitle(field)"></div>
                    </template>
                    <!-- 序号列 -->
                    <template
                        slot="__serial___column"
                        slot-scope="text, record, index"
                    >
                        <div class="delete-col-icon">
                            <span>{{ index + 1 }}</span>
                            <!-- 隐藏字段列 -->
                            <template v-for="(field, key) in hiddenFieldColumn">
                                <template>
                                    <!-- 隐藏字段 -->
                                    <component
                                        :is="field.widgetName"
                                        style="display: none"
                                        :key="key"
                                        :isNested="true"
                                        :showLabel="false"
                                        :rowIndex="index"
                                        :parentName="field.parentName"
                                        :parentModel="
                                            getParentModel(
                                                index,
                                                field.parentName
                                            )
                                        "
                                        :fieldName="
                                            getFieldName(
                                                index,
                                                field.item.model,
                                                field.parentName
                                            )
                                        "
                                        :widget="field.item"
                                    >
                                    </component>
                                </template>
                            </template>
                        </div>
                    </template>
                    <!-- 字段列 -->
                    <template
                        v-for="(field, key) in visibleFieldColumn"
                        :slot="field.scopedSlots.customRender"
                        slot-scope="text, record, index"
                    >
                        <component
                            :is="field.widgetName"
                            :key="key"
                            :lang="lang"
                            :isNested="true"
                            :showLabel="false"
                            :rowIndex="index"
                            :parentName="field.parentName"
                            :parentModel="
                                getParentModel(index, field.parentName)
                            "
                            :fieldName="
                                getFieldName(
                                    index,
                                    field.item.model,
                                    field.parentName
                                )
                            "
                            :widget="field.item"
                            @confirm="
                                handleRowConfirm(
                                    field.item,
                                    field.item.model,
                                    index,
                                    $event
                                )
                            "
                            @change="
                                handleRowChange(
                                    field.item,
                                    field.item.model,
                                    index,
                                    ...arguments
                                )
                            "
                        >
                        </component>
                    </template>
                    <!-- 操作列 -->
                    <template
                        slot="__operation___column"
                        slot-scope="text, record, index"
                    >
                        <a-popconfirm
                            :title="t('wg.table.confirmRow')"
                            @confirm="() => onDelete([index])"
                        >
                            <a-button
                                size="small"
                                class="del-row-btn"
                                icon="delete"
                                >{{ t("wg.bt.delete") }}</a-button
                            >
                        </a-popconfirm>
                    </template>
                </a-table>
            </template>
            <template v-else>
                <a-table
                    :scroll="{ x: totalWidth, y: 424 }"
                    size="small"
                    ref="scrollTable"
                    :dataSource="dataSource.slice(0, 10 * currentPage)"
                    :pagination="false"
                    :columns="tableColumns"
                    :loading="tableLoading"
                >
                    <!-- 表头字段 -->
                    <template
                        v-for="(field, key) in visibleFieldColumn"
                        :slot="field.slots.title"
                    >
                        <div :key="key" v-html="renderTitle(field)"></div>
                    </template>
                    <!-- 序列号配置 -->
                    <template
                        slot="__serial___column"
                        slot-scope="text, record, index"
                    >
                        <div class="delete-col-icon">
                            <span>{{ index + 1 }}</span>
                            <!-- 隐藏字段列 -->
                            <template v-for="(field, key) in hiddenFieldColumn">
                                <template>
                                    <!-- 隐藏字段 -->
                                    <component
                                        :is="field.widgetName"
                                        style="display: none"
                                        :key="key"
                                        :isNested="true"
                                        :showLabel="false"
                                        :rowIndex="index"
                                        :parentName="field.parentName"
                                        :parentModel="
                                            getParentModel(
                                                index,
                                                field.parentName
                                            )
                                        "
                                        :fieldName="
                                            getFieldName(
                                                index,
                                                field.item.model,
                                                field.parentName
                                            )
                                        "
                                        :widget="field.item"
                                    >
                                    </component>
                                </template>
                            </template>
                        </div>
                    </template>
                    <!-- 字段设置 -->
                    <template
                        v-for="(field, key) in visibleFieldColumn"
                        :slot="field.scopedSlots.customRender"
                        slot-scope="text, record, index"
                    >
                        <span :key="key">
                            <component
                                :is="field.widgetName"
                                :lang="lang"
                                :isNested="true"
                                :showLabel="false"
                                :rowIndex="index"
                                :parentName="field.parentName"
                                :parentModel="
                                    getParentModel(index, field.parentName)
                                "
                                :fieldName="
                                    getFieldName(
                                        index,
                                        field.item.model,
                                        field.parentName
                                    )
                                "
                                :widget="field.item"
                                @confirm="
                                    handleRowConfirm(
                                        field.item,
                                        field.item.model,
                                        index,
                                        $event
                                    )
                                "
                                @change="
                                    handleRowChange(
                                        field.item,
                                        field.item.model,
                                        index,
                                        ...arguments
                                    )
                                "
                            >
                            </component>
                        </span>
                    </template>
                </a-table>
                <span>共{{ cacheData.length }}条记录</span>
            </template>
        </template>
        <!-- 面板方式显示 -->
        <template v-else>
            <div
                v-for="(item, index) in dataSource"
                :key="item.key"
                class="panel-row"
            >
                <div style="display: flex; align-items: center">
                    <div style="width: 100px" v-if="!disabled">
                        <a-popconfirm
                            :title="t('wg.table.confirmRow')"
                            @confirm="() => onDelete([index])"
                        >
                            <a-button
                                size="small"
                                class="del-row-btn"
                                icon="delete"
                                >{{ t("wg.bt.delete") }}</a-button
                            >
                        </a-popconfirm>
                    </div>
                    <div style="flex: 1">
                        <a-row type="flex">
                            <template v-for="(field, key) in panelColumns">
                                <a-col
                                    v-show="isShowWidget(field.item)"
                                    :key="key"
                                    v-bind="customCell(field, item)"
                                    class="wg-grid-col"
                                    :xs="24"
                                    :sm="12"
                                    :md="12"
                                    :lg="8"
                                    :xl="8"
                                    :xxl="8"
                                >
                                    <component
                                        :is="field.widgetName"
                                        :key="key"
                                        :lang="lang"
                                        :isNested="true"
                                        :showLabel="true"
                                        :rowIndex="index"
                                        :parentName="field.parentName"
                                        :parentModel="
                                            getParentModel(
                                                index,
                                                field.parentName
                                            )
                                        "
                                        :fieldName="
                                            getFieldName(
                                                index,
                                                field.item.model,
                                                field.parentName
                                            )
                                        "
                                        :widget="field.item"
                                        @confirm="
                                            handleRowConfirm(
                                                field.item,
                                                field.item.model,
                                                index,
                                                $event
                                            )
                                        "
                                        @change="
                                            handleRowChange(
                                                field.item,
                                                field.item.model,
                                                index,
                                                ...arguments
                                            )
                                        "
                                    >
                                    </component>
                                </a-col>
                            </template>
                        </a-row>
                    </div>
                </div>
            </div>
            <div
                v-if="!dataSource.length"
                class="ant-table-placeholder"
                style="border: 1px solid #e8e8e8"
            >
                <a-empty :image="emptyImg" class="ant-empty-normal" />
            </div>
        </template>
    </div>
</template>
<script>
// import debounce from 'lodash/debounce';
import baseMixin from "../../lib/baseMixin";
import widgetType from "../../widget-container/widgetType";
import { getLangValue } from "../../lib";
/* eslint-disable */
const emptyImg =
    "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
/* eslint-enable */

export default {
    mixins: [baseMixin],
    data() {
        // 自定义表头cell，支持resize列
        // this.components = {
        //   header: {
        //     cell: this.ResizeableTitle,
        //   },
        // };
        return {
            dataSource: [],
            visible: false,
            modalTitle: "",
            modalData: {},
            visibleFieldColumn: [],
            hiddenFieldColumn: [],
            totalWidth: 220,
            // 选择列
            selectedRowKeys: [],
            emptyImg,
            currentPage: 1,
            cacheData: [],
            tableLoading: false,
            tableScroll: false,
        };
    },
    computed: {
        // 表格列
        tableColumns() {
            const visibleFieldColumn = this.calVisibleTableColumns();
            const hiddenFieldColumn = this.calHiddenTableColumns();
            this.setFieldColumn(visibleFieldColumn, hiddenFieldColumn);
            if (!this.disabled) {
                return [
                    {
                        title: "#",
                        align: "center",
                        width: 50,
                        dataIndex: "__serial__",
                        scopedSlots: { customRender: "__serial___column" },
                    },
                    ...visibleFieldColumn,
                    {
                        title: this.t("wg.bt.operation"),
                        align: "center",
                        fixed: "right",
                        width: 80,
                        dataIndex: "__operation__",
                        scopedSlots: { customRender: "__operation___column" },
                    },
                ];
            }
            return [
                {
                    title: "#",
                    align: "center",
                    width: 50,
                    dataIndex: "__serial__",
                    scopedSlots: { customRender: "__serial___column" },
                },
                ...visibleFieldColumn,
            ];
        },
        // 面板显示列
        panelColumns() {
            const parentName = this.widget.model;
            // 先分类出普通字段和隐藏字段
            const visibleFieldColumn = this.widget.tableColumns.map((col) => {
                const { model: dataIndex } = col;
                return {
                    item: col,
                    dataIndex,
                    widgetName: widgetType[col.type],
                    parentName,
                };
            });
            return visibleFieldColumn;
        },
        // 行checkbox 复选数据
        rowSelection() {
            if (this.disabled) {
                return null;
            }
            const { selectedRowKeys, onSelectChange } = this;
            return {
                selectedRowKeys,
                onChange: onSelectChange,
            };
        },
        customCell() {
            return (field, record) => {
                const customCellKey = `${this.fieldName}_${field.dataIndex}_customCell`;
                if (this.formContext) {
                    const customCell = this.formContext.$attrs[customCellKey];
                    if (customCell) {
                        return customCell(record);
                    }
                }
                return null;
            };
        },
    },
    mounted() {
        // 获取路由参数
        const { defKey } = this.$route.query;
        // 暂时写死白名单
        const whiteList = this.remote.getWhiteUrlList();
        if (defKey) {
            // 匹配数据 传入进来的数据
            const data = whiteList.find((item) => item === defKey);
            if (data && this.disabled) {
                this.tableScroll = true;
            }
        }
        this.$nextTick(() => {
            const tableComponent = this.$refs.scrollTable;
            if (tableComponent) {
                const tableContainer =
                    tableComponent.$el.querySelector(".ant-table-body");
                tableContainer.addEventListener("scroll", this.handleScroll);
            }
        });
    },
    // 销毁时移除事件
    beforeDestroy() {
        const tableComponent = this.$refs.scrollTable;
        if (tableComponent) {
            const tableContainer =
                tableComponent.$el.querySelector(".ant-table-body");
            tableContainer.removeEventListener("scroll", this.handleScroll);
        }
    },

    methods: {
        handleScroll() {
            //滚动的事件
            const tableComponent = this.$refs.scrollTable;
            const tableContainer =
                tableComponent.$el.querySelector(".ant-table-body");
            const scrollPosition = tableContainer.scrollTop;
            const isAtBottom =
                tableContainer.scrollHeight - scrollPosition ===
                tableContainer.clientHeight;
            if (isAtBottom) {
                // 已滚动到底部，执行相应操作
                this.currentPage += 1;
                // 获取model数据
                const newRecord = this.cacheData.slice(
                    (this.currentPage - 1) * 10,
                    this.currentPage * 10
                );
                if (newRecord.length) {
                    this.tableLoading = true;
                    setTimeout(() => {
                        this.updateImportData(newRecord);
                        this.tableLoading = false;
                    }, 0);
                }
            }
        },

        calVisibleTableColumns() {
            // 先分类出普通字段和隐藏字段
            const visibleTableColumns = this.widget.tableColumns.filter(
                (col) => {
                    if (
                        col.options.visible === undefined ||
                        col.options.visible
                    ) {
                        return col.type !== "hidden" && !col.options.hidden;
                    }
                    return false;
                }
            );
            const len = visibleTableColumns.length;
            let totalWidth = 260;
            const parentName = this.widget.model;
            const visibleFieldColumn = visibleTableColumns.map((col, index) => {
                const { model: dataIndex } = col;
                let width = 200;
                // 数组长度小于3，平均宽度
                if (len < 3) {
                    width = (100 / len).toFixed(2) + "%";
                } else {
                    // 如果是长日期，则适当增加宽度
                    if (col.type === "date" && col.options.format.length > 15) {
                        width = 224;
                    } else if (col.type === "number") {
                        width = 160;
                    } else if (
                        col.type === "fileupload" ||
                        col.type === "dialog"
                    ) {
                        width = 260;
                    }
                    totalWidth += width;
                    // 最后一列不设置宽度
                    if (index + 2 > len) {
                        width = null;
                    }
                }

                // 自定义列
                const customCellKey = `${this.fieldName}_${col.model}_customCell`;
                let customCell;
                if (this.formContext) {
                    customCell = this.formContext.$attrs[customCellKey];
                }
                return {
                    item: col,
                    slots: {
                        title: `title_${col.model}`,
                    },
                    dataIndex,
                    width,
                    minWidth: 200,
                    customCell,
                    scopedSlots: { customRender: `column_${dataIndex}` },
                    widgetName: widgetType[col.type],
                    parentName,
                };
            });
            this.setTotalWidth(totalWidth);
            return visibleFieldColumn;
        },
        calHiddenTableColumns() {
            const hiddenTableColumns = this.widget.tableColumns.filter(
                (col) => {
                    if (
                        col.type === "hidden" ||
                        col.options.visible === false
                    ) {
                        return true;
                    }
                    return false;
                }
            );
            const parentName = this.widget.model;
            const hiddenFieldColumn = hiddenTableColumns.map((col) => {
                const { name: title, model: dataIndex } = col;
                return {
                    item: col,
                    title,
                    dataIndex,
                    scopedSlots: { customRender: `column_${dataIndex}` },
                    widgetName: widgetType[col.type],
                    parentName,
                };
            });
            return hiddenFieldColumn;
        },
        initVal(val) {
            if (val) {
                if (
                    this.currentPage === 1 &&
                    this.disabled &&
                    this.tableScroll
                ) {
                    this.cacheData = val.map((item, index) => ({
                        ...item,
                        key: index,
                    }));
                    this.dataSource = this.cacheData.slice(0, 10);
                } else {
                    // 1.1.15 发现，从子表开头删除行，在触发后边行事件，重新赋值，会报错
                    this.dataSource = val.map((item, index) => ({
                        ...item,
                        key: index,
                    }));
                }
            } else {
                this.dataSource = [];
            }
        },
        // 是否隐藏
        isShowWidget(widget) {
            if (widget.type === "hidden" || widget.options.visible === false) {
                return false;
            }
            return !widget.options.hidden;
            // return widget.type !== 'hidden' && !widget.options.hidden;
        },
        // 给特殊组件设置样式
        getClassName(type) {
            let className = "";
            switch (type) {
                case "treeSelect":
                case "select":
                    className = "form-item-select";
                    break;
                default:
                    break;
            }
            return className;
        },
        /**
         * 自定义：设置表格头标题
         */
        renderTitle(field) {
            const { options = {}, langTitle, i18nTitle } = field.item;
            let { name } = field.item;
            const { required = false } = options;
            if (i18nTitle) {
                name = i18nTitle;
            } else if (langTitle) {
                name = getLangValue(field.item.langTitle, this.lang);
            }
            if (required) {
                return `<label class="ant-form-item-required">${name}</label>`;
            }
            return name;
        },
        /**
         * 行选择 change 事件
         */
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        // 私有：设置字段列
        setFieldColumn(visibleFieldColumn, hiddenFieldColumn) {
            this.visibleFieldColumn = visibleFieldColumn;
            this.hiddenFieldColumn = hiddenFieldColumn;
        },
        // 设置宽度
        setTotalWidth(totalWidth) {
            this.totalWidth = totalWidth;
        },
        /**
         * 行删除方法
         */
        onDelete(k) {
            const keys = [...this.dataSource];
            const newKeys = keys.filter((item, index) => !k.includes(index));
            if (this.formContext) {
                const record = this.formContext.form.getFieldValue(
                    this.widget.model
                );
                this.triggerChange("delRow", newKeys);
                // 等待父容器渲染完成后，在重新赋值
                this.$nextTick(() => {
                    const newRecord = record?.filter(
                        (item, index) => !k.includes(index)
                    );
                    this.formContext.form.setFieldsValue({
                        [this.widget.model]: newRecord,
                    });
                });
            }
        },

        /**
         * 外部：添加行
         */
        addRow() {
            const keys = [...this.value];
            const len = keys.length;
            let maxIndex = 0;
            if (len) {
                maxIndex = keys[len - 1].key + 1;
            }
            const newKeys = keys.concat({ key: maxIndex });
            this.triggerChange("addRow", newKeys);
        },
        /**
         * 外部：删除选择行
         */
        delRow() {
            // if (this.selectedRowKeys.length) {
            //   const keys = [...this.selectedRowKeys].sort((a, b) => b - a);
            //   this.selectedRowKeys = [];
            //   this.onDelete(keys);
            // }
            const selectedKeys = this.selectedRowKeys;
            if (selectedKeys.length) {
                const dataSource = [...this.dataSource];
                // 查找出 selectedRowKeys 在数组中的序号
                const newKeys = dataSource
                    .map((item, index) => {
                        if (selectedKeys.includes(item.key)) {
                            return index;
                        }
                        return -1;
                    })
                    .filter((index) => index > -1);
                const keys = [...newKeys].sort((a, b) => b - a);
                // console.log('keys', JSON.stringify(keys));
                this.selectedRowKeys = [];
                this.onDelete(keys);
            }
        },
        // editRow(index) {
        //   this.rowIndex = index;
        //   this.optionType = 'edit';
        //   this.modalData = this.dataSource[index];
        //   this.modalTitle = `编辑:${this.widget.name}`;
        //   this.visible = true;
        //   // const { form } = this.$refs.collectionForm;
        // },

        /**
         * 向上触发事件
         */
        triggerChange(actionType, value) {
            // 先触发辅助子表内部事件，使页面执行渲染，
            const rows = [...value];
            this.$emit("change", rows, actionType);
            // 因此在 nextTick 后，重新获取真正的子表数据，并且向上抛出事件
            this.$nextTick(() => {
                const { fieldName: field } = this;
                if (actionType === "addRow") {
                    this.dispatch("wgForm", `on-${this.fieldName}-addRow`, {
                        type: "table",
                        rowIndex: rows.length - 1,
                        field,
                        actionType,
                    });
                }
                // 删除行事件
                if (actionType === "delRow") {
                    this.dispatch("wgForm", `on-${this.fieldName}-delRow`, {
                        type: "table",
                        rowIndex: rows.length - 1,
                        field,
                        actionType,
                        rows,
                    });
                }
                // end next
            });
        },
        // 单元格事件，触发行事件
        // @change="handleRowChange(field.item,field.item.model, index,$event)"
        handleRowChange(item, field, index, value, otherVal) {
            this.$nextTick(() => {
                const { model: parentField } = this.widget;
                const values = this.formContext.getFieldsValue([parentField]);
                const val = values[parentField];
                this.dispatch("wgForm", `on-${this.fieldName}-row-change`, {
                    item,
                    field,
                    index,
                    rowIndex: index,
                    value,
                    parentField,
                    row: val[index],
                    otherVal,
                });
                // this.triggerChange('editRow', [...this.value]);
            });
        },

        // 单元格事件，触发行事件
        handleRowConfirm(item, field, index, value) {
            this.$nextTick(() => {
                const { model: parentField } = this.widget;
                if (this.formContext) {
                    const values = this.formContext.getFieldsValue([
                        parentField,
                    ]);
                    const val = values[parentField];
                    this.dispatch(
                        "wgForm",
                        `on-${this.fieldName}-row-confirm`,
                        {
                            item,
                            field,
                            index,
                            rowIndex: index,
                            value,
                            parentField,
                            row: val[index],
                        }
                    );
                }
            });
        },
        /**
         * 组件类型
         */
        getName(type) {
            return widgetType[type];
        },
        /**
         * 字段名称
         */
        getFieldName(index, model, parentName) {
            return `${parentName}[${index}].${model}`;
        },
        /**
         * 父属性名称和序号
         */
        getParentModel(index, parentName) {
            return `${parentName}[${index}]`;
        },
        /**
         * 布局变更
         */
        layoutChange(layout) {
            // 先重新整理 dataSource
            this.dataSource = this.dataSource.map((item, index) => ({
                key: index,
            }));
            if (this.formContext) {
                // 先获取当前表单值
                const val = this.formContext.getFieldsValue([this.fieldName]);
                // 异步宣传中完成表单赋值
                this.$nextTick(() => {
                    // 布局变更后，重新设置值
                    this.formContext.setFieldsValue({
                        [this.fieldName]: val[this.fieldName] || [],
                    });
                    // 必须在表单赋值完成后，再通知form，布局变更了，处理子表初始化
                    this.$nextTick(() => {
                        this.dispatch(
                            "wgForm",
                            `on-${this.fieldName}-layout-change`,
                            { layout, parentField: this.fieldName }
                        );
                    });
                });
            }
        },
        /**
         * 数据更新
         * */
        updateImportData(data) {
            const val = this.formContext.getFieldsValue([this.fieldName]);
            val[this.fieldName].push(...data);
            this.$nextTick(() => {
                this.formContext.setFieldsValue({
                    [this.fieldName]: val[this.fieldName] || [],
                });
            });
        },
        handlePageChange({ current }) {
            this.pageNum = current;
        },
    },
    // end methods
};
</script>
